import React from 'react';
import { injectIntl } from 'react-intl';
import { InfoBox, Box } from '@landtrustinc/design-system';
import useLandDetails from '../../hooks/useLandDetails';

const SectionLandDetails = ({ landDetails, categories, intl, acreage }) => {
  const { features } = useLandDetails({ landDetails, categories, intl, acreage });

  if (!features || features.length === 0) {
    return null;
  }

  return (
    <Box mb="var(--spacing-5)">
      <InfoBox
        heading={intl.formatMessage({ id: 'ListingPage.landDetailsTitle' })}
        features={features}
      />
    </Box>
  );
};

export default injectIntl(SectionLandDetails);
